import React, { useState } from 'react';

import DomainTable from '../../components/domainTable.js'
import WebsiteSecondaryPageTitle from '../../components/websiteSecondaryPageTitle.js'

import {BacklinkingWebsitesPageResult} from '../../../../server/routes/website.js'

interface WebsiteBacklinksWebsitesPageProps {
    server: string,
    pageData: unknown
}
export default function WebsiteBacklinksWebsites({ server, pageData }: WebsiteBacklinksWebsitesPageProps) {

	let [data, setData] = useState(pageData as BacklinkingWebsitesPageResult);

    return (<>
        <WebsiteSecondaryPageTitle domainPageHeader={data.DomainPageHeader}/>
        <section className="section section-sm">
            <div className="container">
                <DomainTable 
                    domainList={data.DomainList}
                />    
            </div>
        </section>
    </>)
}
